export const school_bus_schools = new Map([
  ["309", "Chanel College / Hadlow Preparatory School / Mākoura College"],
  ["313", "Hadlow Preparatory School / Wairarapa College"],
  ["315", "Hadlow Preparatory School / Masterton Intermediate School"],
  [
    "366",
    "Chanel College / Hadlow Preparatory School / Masterton Intermediate School / St Matthew’s Collegiate School / Wairarapa College",
  ],
  [
    "402",
    "Redwood School / Tawa College / Tawa Intermediate School / Tawa School",
  ],
  ["421", "Bishop Viard College"],
  ["429", "Aotea College"],
  ["430", "Brandon Intermediate School / Porirua College"],
  ["440", "Aotea College"],
  ["441", "Aotea College"],
  ["442", "Aotea College"],
  ["444", "Aotea College / Paremata School"],
  ["445", "Aotea College"],
  ["460", "Tawa College / Tawa Intermediate School"],
  ["461", "Tawa Intermediate School"],
  ["465", "Paremata School / Plimmerton School / St Theresa’s School"],
  ["500", "Kapakapanui School / Waikanae School"],
  ["501", "Kapakapanui School / Our Lady of Kāpiti School / Waikanae School"],
  ["505", "Kapakapanui School / Our Lady of Kāpiti School / Waikanae School"],
  ["507", "Paraparaumu College"],
  ["508", "Kapakapanui School / Paraparaumu College"],
  ["509", "Kāpiti College"],
  ["510", "Paraparaumu College"],
  ["512", "Kapakapanui School / Kāpiti College"],
  ["530", "Kāpiti College"],
  [
    "611",
    "Queen Margaret College / St Mary’s College / Wellington Girls’ College",
  ],
  [
    "612",
    "Queen Margaret College / St Mary’s College / Wellington Girls’ College",
  ],
  ["614", "St Mary’s College / Wellington Girls’ College"],
  ["615", "Wellington Girls’ College"],
  ["616", "St Mary’s College / Wellington Girls’ College"],
  ["617", "Queen Margaret College / St Mary’s College"],
  [
    "619",
    "Queen Margaret College / St Mary’s College / Wellington Girls’ College",
  ],
  [
    "621",
    "Queen Margaret College / St Mary’s College / Wellington Girls’ College",
  ],
  [
    "623",
    "Queen Margaret College / St Mary’s College / Wellington Girls’ College",
  ],
  [
    "625",
    "Queen Margaret College / St Mary’s College / Wellington Girls’ College",
  ],
  ["627", "Newlands College / Newlands Intermediate"],
  ["633", "Newlands College / Newlands Intermediate"],
  ["634", "Newlands College / Newlands Intermediate"],
  ["635", "Newlands College / Newlands Intermediate"],
  ["646", "Onslow College / St Brigid’s School"],
  ["648", "Raroa Normal Intermediate School"],
  ["654", "South Wellington Intermediate School / St Mark’s School"],
  ["667", "Karori West Normal School / St Teresa’s School (Karori)"],
  [
    "673",
    "Cardinal McKeefry School / Ōtari School / Samuel Marsden Collegiate School",
  ],
  [
    "674",
    "Cardinal McKeefry School / Ōtari School / Samuel Marsden Collegiate School",
  ],
  ["677", "Samuel Marsden Collegiate School"],
  ["680", "Raroa Normal Intermediate School / St Brigid’s School"],
  ["681", "Onslow College / Raroa Normal Intermediate School"],
  ["682", "Onslow College / Raroa Normal Intermediate School"],
  [
    "685",
    "Cardinal McKeefry School / Onslow College / Ōtari School / Raroa Normal Intermediate School",
  ],
  ["700", "Wellington College / St Mark’s School"],
  ["704", "Wellington College"],
  ["711", "St Mark’s School / Wellington East Girls’ College"],
  [
    "712",
    "Rongotai College / St Mark’s School / St Patrick’s College / Wellington College / Wellington East Girls’ College",
  ],
  [
    "715",
    "Wellington College / Wellington East Girls’ College / Wellington High School",
  ],
  ["716", "St Mark’s School"],
  ["717", "Wellington College"],
  ["718", "Wellington High School"],
  ["719", "Wellington High School"],
  ["721", "Wellington East Girls’ College"],
  ["722", "Wellington East Girls’ College"],
  [
    "725",
    "Wellington College / Wellington East Girls’ College / Wellington High School",
  ],
  ["726", "Wellington High School"],
  ["730", "Wellington East Girls’ College"],
  [
    "731",
    "St Mark’s School / Wellington College / Wellington East Girls’ College",
  ],
  ["732", "Queen Margaret College / Wellington Girls’ College"],
  [
    "734",
    "St Mark’s School / Wellington College / Wellington East Girls’ College / Wellington High School",
  ],
  [
    "736",
    "St Mark’s School / Wellington College / Wellington East Girls’ College / Wellington High School",
  ],
  [
    "737",
    "Wellington College / Wellington East Girls’ College / Wellington High School",
  ],
  ["739", "Wellington College"],
  ["740", "Wellington College / Wellington High School"],
  ["741", "Wellington College / Wellington East Girls’ College"],
  [
    "742",
    "St Mark’s School / Wellington College / Wellington East Girls’ College / Wellington High School",
  ],
  [
    "743",
    "Queen Margaret College / St Mary’s College / Wellington College / Wellington East Girls’ College / Wellington Girls’ College / Wellington High School",
  ],
  ["744", "Wellington College"],
  ["745", "Wellington College"],
  [
    "746",
    "St Mark’s School / St Patrick’s College / Wellington College / Wellington East Girls’ College / Wellington High School",
  ],
  ["751", "Rongotai College / St Patrick’s College"],
  ["753", "St Patrick’s College"],
  ["754", "Rongotai College"],
  ["755", "Rongotai College / St Catherine’s College"],
  ["758", "Evans Bay Intermediate School"],
  ["760", "Evans Bay Intermediate School / Kahurangi School"],
  ["761", "St Patrick’s College"],
  ["762", "Rongotai College"],
  [
    "764",
    "Wellington College / Wellington East Girls’ College / Wellington High School",
  ],
  ["767", "St Patrick’s College"],
  [
    "768",
    "Rongotai College / St Patrick’s College / Wellington College / Wellington East Girls’ College / Wellington High School",
  ],
  ["769", "St Patrick’s College / Wellington College / Wellington High School"],
  [
    "770",
    "Rongotai College / St Patrick’s College / Wellington College / Wellington East Girls’ College / Wellington High School",
  ],
  [
    "774",
    "Rongotai College / South Wellington Intermediate School / St Catherine’s College / St Patrick’s College",
  ],
  ["775", "St Catherine’s College / St Patrick’s College"],
  ["776", "Rongotai College"],
  ["784", "Scots College"],
  ["791", "Scots College"],
  [
    "823",
    "Chilton Saint James School / Hutt Intermediate School / Naenae College / St Bernard’s College / St Oran’s College",
  ],
  ["825", "Avalon Intermediate School"],
  ["828", "Taita College"],
  [
    "842",
    "Chilton Saint James School / Hutt Intermediate School / Hutt Valley High School / Sacred Heart College / Ss Peter and Paul School / St Bernard’s College / St Oran’s College",
  ],
  [
    "843",
    "Hutt Intermediate School / Naenae College / Naenae Intermediate School / Ss Peter and Paul School / St Bernard’s College",
  ],
  [
    "848",
    "Eastern Hutt School / Hutt Intermediate School / Ss Peter and Paul School",
  ],
  [
    "849",
    "Chilton Saint James School / Eastern Hutt School / Hutt Intermediate School / Hutt Valley High School / Sacred Heart College / St Bernard’s College / St Oran’s College",
  ],
  [
    "852",
    "Chilton Saint James School / Hutt Intermediate School / Hutt Valley High School / Sacred Heart College / Ss Peter and Paul School / St Bernard’s College / St Oran’s College",
  ],
  [
    "853",
    "Chilton Saint James School / Hutt Valley High School / Sacred Heart College / St Bernard’s College / St Oran’s College",
  ],
  [
    "854",
    "Chilton Saint James School / Hutt Intermediate School / Hutt Valley High School / Sacred Heart College / Ss Peter and Paul School / St Bernard’s College",
  ],
  ["855", "Hutt Intermediate School / Ss Peter and Paul School"],
  ["860", "Hutt Valley High School"],
  ["866", "Hutt Valley High School"],
  ["868", "St Bernard’s College"],
  [
    "874",
    "St Claudine Thevenet School / Wainuiomata High School / Wainuiomata Intermediate School",
  ],
  ["886", "Muritai School / San Antonio School"],
  ["887", "Hutt Valley High School"],
  [
    "888",
    "Chilton Saint James School / Sacred Heart College / St Bernard’s College / St Oran’s College",
  ],
  ["901", "St Patrick’s College Silverstream"],
  ["906", "Birchville School / Plateau School"],
  ["911", "Chilton Saint James School / St Oran’s College"],
  [
    "915",
    "Fergusson Intermediate / Maidstone Intermediate / Silverstream School",
  ],
  ["916", "Silverstream School / Upper Hutt College"],
  [
    "929",
    "Fraser Crescent School / Maidstone Intermediate / Oxford Crescent School / St Joseph’s School",
  ],
  ["930", "Fergusson Intermediate / Heretaunga College / Upper Hutt College"],
  ["931", "Chilton Saint James School / Sacred Heart College"],
  [
    "935",
    "Maidstone Intermediate / Oxford Crescent School / St Joseph’s School",
  ],
  [
    "951",
    "Hutt International Boys’ School / St Patrick’s College Silverstream",
  ],
  [
    "953",
    "Fergusson Intermediate / St Patrick’s College Silverstream / Upper Hutt College",
  ],
  ["955", "Upper Hutt College"],
]);
